/**
 * System Tools Traceroute Store
 *
 * @since 2018-03-12
 * @author mk.ko
 */

import { checkIpv6 } from '~/utils/ip'

export const state = () => ({
  taskId: void 0,
  taskStatus: '',
  resultContents: []
})

export const mutations = {
  setTaskStart (state, payload) {
    state.taskId = payload.id
    state.taskStatus = payload.status
  },
  setTaskProgress (state, payload) {
    state.taskStatus = payload.status
    state.resultContents = payload.attributes.contents
  },
  resetTaskResult (state) {
    state.taskId = void 0
    state.taskStatus = ''
    state.resultContents = []
  }
}

export const actions = {
  async execCommandStart ({ commit }, { ipSegment }) {
    try {
      const isIpv6 = checkIpv6(ipSegment)
      const apiUri = isIpv6 ? '/api/sm/tools/traceroute6' : '/api/sm/tools/traceroute'

      const res = await this.$axios.$post(apiUri, {
        target: ipSegment
      }, {
        loading: false,
        successAlert: false
      })

      if (res.code === 'async' && res.result.id !== '') {
        await commit('setTaskStart', res.result)
      }
      return res
    } catch (e) {
      return {
        code: 'nok',
        errors: e
      }
    }
  },
  async execCommandProgress ({ commit, state }, { ipSegment }) {
    try {
      const isIpv6 = checkIpv6(ipSegment)
      const apiUri = isIpv6 ? `/api/sm/tools/traceroute6/${state.taskId}` : `/api/sm/tools/traceroute/${state.taskId}`

      const res = await this.$axios.$get(apiUri, {
        loading: false,
        successAlert: false
      })

      if (res.code === 'ok') {
        await commit('setTaskProgress', res.result)
      }
      return res
    } catch (e) {
      return {
        code: 'nok',
        errors: e
      }
    }
  }
}

export const getters = {
}

export const strict = false
